/* eslint-disable camelcase */
import isUndefined from "lodash/fp/isUndefined";
import map from "lodash/fp/map";
import apis from "../../core/apis";
class Controller {
  constructor(
    $stateParams,
    $injector,
    EventTransforms,
    Sections,
    Upload,
    Lists
  ) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.Upload = Upload;
    this.Events = $injector.get("Events");
    this.Station = $injector.get("Station");
    this.Lists = Lists.all;
    this.Event = $injector.get("MarketingEvents");
    this.sections = Sections.settingsSections;
    this.onUpdate = this.Events.getUpdateEvent("event");
    this.onUpdateCities = this.Events.getUpdateEvent("cityUpdateDetail");
    this.onUpdateStations = this.Events.getUpdateEvent("stationUpdate");
    this.colorsFetchedEvent = this.Events.getUpdateEvent("colorsFetched");
    this.EventTransforms = EventTransforms;
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;

    this.selectTypeList = this.Lists.eventStationsTypes;
    this.selectTitle = "Type";

    const mapStations = (item) => {
      if (item.name && item.name._id) {
        return {
          id: item.name._id,
          type: item.type,
        };
      }

      return {
        id: item._id,
        type: item.type,
      };
    };

    const mapKeyId = (item) => {
      if (item.name && item.name._id) {
        return item.name._id;
      }

      return item._id;
    };

    const onUpdate = (item) => {
      let updatedItem = {};
      updatedItem[item.key] = isUndefined(item.value)
        ? item.name
          ? item.name._id
          : null
        : item.value;
      if (
        item.key === "background_color" ||
        item.key === "title_color" ||
        item.key === "description_color"
      ) {
        updatedItem = item.value;
        const suggestion_theme = {};
        suggestion_theme[item.key] = updatedItem;
        this.Event.updateAction(
          this.$stateParams.id,
          item.methodName,
          suggestion_theme
        ).$promise.then(
          (response) => {
            this.event = this.EventTransforms.justify(response);
            this.Events.emit(showNotificationEvent, {
              message: "Event updated sucessfully",
            });
          },
          (response) => this.Events.emit(errorEvent, response.data)
        );
      } else {
        this.Event.updateAction(
          this.$stateParams.id,
          item.methodName,
          updatedItem
        ).$promise.then(
          (response) => {
            this.event = this.EventTransforms.justify(response);
            this.Events.emit(showNotificationEvent, {
              message: "Event updated sucessfully",
            });
          },
          (response) => this.Events.emit(errorEvent, response.data)
        );
      }
    };
    const onUpdateCities = (options) => {
      const updatedItem = {};
      updatedItem[options.name] = map(mapKeyId)(options[options.name]);
      this.Event.updateAction(
        this.$stateParams.id,
        "update_cities",
        updatedItem
      ).$promise.then(
        (response) => {
          this.event = this.EventTransforms.justify(response);
          this.Events.emit(showNotificationEvent, {
            message: "Event updated sucessfully",
          });
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    const onUpdateStations = (options) => {
      const updatedStationItem = {};
      updatedStationItem[options.name] = map(mapStations)(
        options[options.name]
      );
      this.Event.updateAction(
        this.$stateParams.id,
        "update_stations",
        updatedStationItem
      ).$promise.then(
        (response) => {
          this.event = this.EventTransforms.justify(response);
          this.Events.emit(showNotificationEvent, {
            message: "Event updated sucessfully",
          });
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };

    this.get = () => {
      this.Event.get(this.$stateParams.id).$promise.then(async (response) => {
        this.event = this.EventTransforms.justify(response);
        this.Events.emit(
          this.colorsFetchedEvent,
          this.event.search_suggestion_theme
        );
      });
    };

    this.Events.on(this.onUpdate, onUpdate);
    this.Events.on(this.onUpdateCities, onUpdateCities);
    this.Events.on(this.onUpdateStations, onUpdateStations);
    this.get();
  }
  onPictureChange() {
    if (this.event.search_suggestion_theme.icon_url) {
      const data = { picture: this.event.search_suggestion_theme.icon_url };
      const url = apis.marketingEvents + this.$stateParams.id + "/update_icon";

      this.Upload.upload({
        method: "POST",
        url,
        data,
      }).then(
        (response) => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Event picture has been uploaded successfully",
          });
          this.event = this.EventTransforms.justify(response.data);
        },
        (response) => {
          const message =
            response.data.message || "Can't upload your picture !";
          this.Events.emit(this.errorNotificationEvent, { message });
        }
      );
    }
  }
  onPortraitPictureChange() {
    if (this.event.explore_featured_theme.portrait_image_url) {
      const data = {
        picture: this.event.explore_featured_theme.portrait_image_url,
      };
      const url =
        apis.marketingEvents + this.$stateParams.id + "/update_portrait_image";

      this.Upload.upload({
        method: "POST",
        url,
        data,
      }).then(
        (response) => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Portrait picture has been uploaded successfully",
          });
          this.event = this.EventTransforms.justify(response.data);
        },
        (response) => {
          const message =
            response.data.message || "Can't upload your picture !";
          this.Events.emit(this.errorNotificationEvent, { message });
        }
      );
    }
  }
  onLandscapePictureChange() {
    if (this.event.explore_featured_theme.landscape_image_url) {
      const data = {
        picture: this.event.explore_featured_theme.landscape_image_url,
      };
      const url =
        apis.marketingEvents + this.$stateParams.id + "/update_landscape_image";

      this.Upload.upload({
        method: "POST",
        url,
        data,
      }).then(
        (response) => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Landscape picture has been uploaded successfully",
          });
          this.event = this.EventTransforms.justify(response.data);
        },
        (response) => {
          const message =
            response.data.message || "Can't upload your picture !";
          this.Events.emit(this.errorNotificationEvent, { message });
        }
      );
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/event/event.controller.js